import { Cancel } from "@mui/icons-material";
import { Alert, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSocket } from "src/_contexts/socket";

export default function ShipmentCreationFailedAlert() {
  const {t} = useTranslation()
  const theme = useTheme()
  const { socket } = useSocket();
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {

    const shipmentFailedHandler = (data) => {
      if (data?.type === "SHIPMENT_CREATION_FAILED") {
        setOpenAlert(true);
      }
    };

    if (socket) {
      socket.on("notification", shipmentFailedHandler);
    }

    return () => {
      socket?.off("notification", shipmentFailedHandler);
    };

  }, [socket]);

  if (!openAlert) return null;

  return (
    <Alert
      variant="filled"
      icon={<Cancel />}
      onClose={() => setOpenAlert(false)}
      sx={{ bgcolor: theme.palette.error.main, mx: 1 , mb: 1 }}
    >
      {t("Shipment Creation Failed For This Order")}
    </Alert>
  );
}
